import { useContext } from "react";
import LocalizedStrings from "react-localization";
import { useNavigate } from "react-router-dom";

import { LayoutContext } from "layout/context/LayoutContext";

const PermissionsRequired = () => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();

  if (me.permissions?.length > 0) return navigate("/");

  return (
    <>
      <h4>{strings.title}</h4>
      <h5 className="text-muted mt-3">Contacto: info@cimaiot.com</h5>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    title:
      "Por favor comuniquese con el administrador de Cima IoT para obtener permisos de uso del aplicativo.",
  },
});

export default PermissionsRequired;
